import { Fetch } from 'lib/Fetch';

export function downloadPaymentPlan({ projectId }) {
  return new Fetch('api_2')
    .url(`/company/company-info/excel-company-payment-plan/${projectId}`)
    .method('get')
    .userToken()
    .send();
}
